
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("giU2u", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bde9cc018c642020$export$6503ec6e8aabbaf; }, function (v) { return $bde9cc018c642020$export$6503ec6e8aabbaf = v; });
var $bde9cc018c642020$export$6503ec6e8aabbaf;
var $bde9cc018c642020$export$f7ad0328861e2f03;
"use strict";
var $bde9cc018c642020$var$mapping = new Map();
function $bde9cc018c642020$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bde9cc018c642020$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bde9cc018c642020$var$resolve(id) {
    var resolved = $bde9cc018c642020$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bde9cc018c642020$export$6503ec6e8aabbaf = $bde9cc018c642020$var$register;
$bde9cc018c642020$export$f7ad0328861e2f03 = $bde9cc018c642020$var$resolve;

});

var $9b1f3288f4eb9748$exports = {};

(parcelRequire("giU2u")).register(new URL("", import.meta.url).toString(), JSON.parse('["ehesI","index.e687232a.js","5l3vW","Icon-Phone-call-dark.06229393.png","dmHsL","Icon-Phone-call.2065ff98.png","shmUo","Icon-Burger-menu-dark.72c84e5f.png","b7sQQ","Icon-Burger-menu.fdf49836.png","3NMJC","Icon-Close-dark.a660d1f5.png","7UdnU","header-logo-dark.a4d48ba4.png","W7pVB","header-logo.10e4bc11.png","2o2sT","Icon-Close.f5c91ce9.svg"]'));

"use strict";
const $09e991522ca7e64e$var$page = document.documentElement;
const $09e991522ca7e64e$var$switcher = $09e991522ca7e64e$var$page.querySelector(".theme-switcher");
const $09e991522ca7e64e$var$topBarIconCall = $09e991522ca7e64e$var$page.querySelector(".top-bar__icon-call");
const $09e991522ca7e64e$var$topBarIconBurger = $09e991522ca7e64e$var$page.querySelector(".top-bar__icon-burger");
const $09e991522ca7e64e$var$topBarIconClose = $09e991522ca7e64e$var$page.querySelector(".top-bar__icon-close");
const $09e991522ca7e64e$var$headerLogo = $09e991522ca7e64e$var$page.querySelector(".header__logo");
const $09e991522ca7e64e$var$menuLogo = document.querySelector(".menu .header__logo");
const $09e991522ca7e64e$var$contactInputName = document.querySelector(".contacts__input-name");
const $09e991522ca7e64e$var$contactInputEmail = document.querySelector(".contacts__input-email");
const $09e991522ca7e64e$var$contactInputTextArea = document.querySelector(".contacts__input-textarea");
var $9902a8018bdd6497$exports = {};
$9902a8018bdd6497$exports = new URL("Icon-Phone-call-dark.06229393.png", import.meta.url).toString();


var $7afc9f318ed28e68$exports = {};
$7afc9f318ed28e68$exports = new URL("Icon-Phone-call.2065ff98.png", import.meta.url).toString();


var $4a15952909359b11$exports = {};
$4a15952909359b11$exports = new URL("Icon-Burger-menu-dark.72c84e5f.png", import.meta.url).toString();


var $e9fc98ca02fd0b0c$exports = {};
$e9fc98ca02fd0b0c$exports = new URL("Icon-Burger-menu.fdf49836.png", import.meta.url).toString();


var $46aa221a6082547b$exports = {};
$46aa221a6082547b$exports = new URL("Icon-Close-dark.a660d1f5.png", import.meta.url).toString();


var $b511eadb04ed6ce3$exports = {};
$b511eadb04ed6ce3$exports = new URL("Icon-Close.f5c91ce9.svg", import.meta.url).toString();


var $9d86c2295d69fde2$exports = {};
$9d86c2295d69fde2$exports = new URL("header-logo-dark.a4d48ba4.png", import.meta.url).toString();


var $56d78323a4088778$exports = {};
$56d78323a4088778$exports = new URL("header-logo.10e4bc11.png", import.meta.url).toString();


$09e991522ca7e64e$var$switcher.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$page.classList.contains("page--dark")) {
        $09e991522ca7e64e$var$page.classList.remove("page--dark");
        $09e991522ca7e64e$var$switcher.classList.remove("switcher--dark");
        $09e991522ca7e64e$var$topBarIconCall.src = $7afc9f318ed28e68$exports;
        $09e991522ca7e64e$var$topBarIconBurger.src = $e9fc98ca02fd0b0c$exports;
        $09e991522ca7e64e$var$topBarIconClose.src = $b511eadb04ed6ce3$exports;
        $09e991522ca7e64e$var$headerLogo.src = $56d78323a4088778$exports;
        $09e991522ca7e64e$var$menuLogo.src = $56d78323a4088778$exports;
    } else {
        $09e991522ca7e64e$var$page.classList.add("page--dark");
        $09e991522ca7e64e$var$switcher.classList.add("switcher--dark");
        $09e991522ca7e64e$var$topBarIconCall.src = $9902a8018bdd6497$exports;
        $09e991522ca7e64e$var$topBarIconBurger.src = $4a15952909359b11$exports;
        $09e991522ca7e64e$var$topBarIconClose.src = $46aa221a6082547b$exports;
        $09e991522ca7e64e$var$headerLogo.src = $9d86c2295d69fde2$exports;
        $09e991522ca7e64e$var$menuLogo.src = $9d86c2295d69fde2$exports;
        $09e991522ca7e64e$var$contactInputName.style = "color: rgb(50, 126, 131)";
        $09e991522ca7e64e$var$contactInputEmail.style = "color: rgb(50, 126, 131)";
        $09e991522ca7e64e$var$contactInputTextArea.style = "color: rgb(50, 126, 131)";
    }
});


//# sourceMappingURL=index.e687232a.js.map
